import { TOrderAttributesActions } from '../order-attributes/order-attributes.actions';
import { TOrderAttributesInfoActionType, TOrderAttributesState } from '../order-attributes/order-attributes.models';

export const initialState: TOrderAttributesState = {
  OrderAttributesInfo: null,
  OrderAttributesTypesInfo: null,
};

export function orderAttributesReducer(state = initialState, action: TOrderAttributesActions): TOrderAttributesState {
  switch (action.type) {
    case TOrderAttributesInfoActionType.GetOrderAttributes:
      return {
        ...state,
        OrderAttributesInfo: null,
      };
    case TOrderAttributesInfoActionType.GetOrderAttributesSuccess:
      return {
        ...state,
        OrderAttributesInfo: action.OrderAttributesRes,
      };
    case TOrderAttributesInfoActionType.GetOrderAttributesTypes:
      return {
        ...state,
        OrderAttributesTypesInfo: null,
      };
    case TOrderAttributesInfoActionType.GetOrderAttributesTypesSuccess:
      return {
        ...state,
        OrderAttributesTypesInfo: action.OrderAttributesTypesRes,
      };
    default:
      return state;
  }
}
